module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (135).ac529e61.jpg";